import React, { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';

import Message from '@/components/Message';
import { postContact } from '@/api';
import { useAsyncState, useMobileDetect } from '@/utils/hooks';
import SendIcon from '@/assets/svg/SendIcon';

import validationSchema from './validationSchema';
import {
  Container, InputContainer, TextInput, Title, Button, MobileBtn,
} from './styles';

const Newsletter = () => {
  const [email, setEmail] = useState('');
  const [alerts, setAlerts] = useAsyncState({});
  const { t } = useTranslation(['footer', 'form']);
  const isMobile = useMobileDetect();

  const handleChange = useCallback((e) => {
    if (alerts.error || alerts.success) {
      setAlerts({});
    }
    setEmail(e.target.value);
  }, [alerts.error, alerts.success, setAlerts]);

  const postData = useCallback((data) => {
    postContact(data)
      .then(() => {
        setAlerts({ success: t('form:success') });
        setEmail('');
      })
      .catch(() => {
        setAlerts({ error: t('form:error') });
      });
  }, [setAlerts, t]);

  const handleSubmit = useCallback((e) => {
    e.preventDefault();

    if (alerts.loading) return;

    setAlerts({ loading: true });
    validationSchema.validate({ email })
      .then(postData)
      .catch((errors) => {
        const [key] = errors.errors;
        setAlerts({ error: t(`form:${key}`) });
      });
  }, [alerts.loading, email, postData, setAlerts, t]);

  const alertMessage = alerts.error || alerts.success;

  return (
    <Container>
      <Title htmlFor="email">{t('newsletter')}</Title>
      <form onSubmit={handleSubmit}>
        <InputContainer>
          <TextInput
            id="email"
            type="email"
            placeholder={t('form:emailPlaceholder')}
            value={email}
            onChange={handleChange}
          />
          <MobileBtn aria-label="submit">
            <SendIcon />
          </MobileBtn>
          <Button>{t('subscribe')}</Button>
        </InputContainer>
        {alertMessage && (
        <Message
          error={Boolean(alerts.error)}
          noMargin={isMobile}
        >
          {alertMessage}
        </Message>
        )}
      </form>
    </Container>
  );
};

export default Newsletter;
